import { type ComponentType } from "react";
import BridgeDebuggerPage from "./components/registry/BridgeDebuggerPage";
import SampleComponent from "./components/registry/SampleComponent";

type RouteConfig = {
  path: string;
  component: ComponentType;
};

export const ROUTES_REGISTRY: RouteConfig[] = [
  {
    path: "sample/component",
    component: SampleComponent,
  },
  {
    path: "bridge/debugger",
    component: BridgeDebuggerPage,
  },
];
